import { useEffect, useState } from 'react';
import network from '../platform/network';

export default function useNetworkStatus() {
    const [connected, setConnected] = useState(null);
    useEffect(() => {
        let active = true;
        let changed = false;
        const unsubscribe = network.onChange(status => {
            changed = true;
            if (active) setConnected(status.connected);
        });
        void network.getStatus().then(status => {
            if (active && !changed) setConnected(status.connected);
        }).catch(() => {});
        return () => { active = false; unsubscribe(); };
    }, []);
    return connected;
}
